import React from "react";
import Button from "../Button/Button";
import { useFormikContext } from "formik";
import { TFormValues } from "./types";

// import { GuideContext } from "./GatewayForm.store";

import styles from './FormStickyCTA.module.scss'

const publication = window._edo_settings.publication;

export const FormStickyCTA = () => {
  const { setFieldValue } = useFormikContext<TFormValues>();
  // console.log({values})
  // console.log({publication})

  const toggleForm = () => {
    setFieldValue('location', publication.location?.slug);
    setFieldValue('concern', publication.concern?.slug);
    setFieldValue('outcomes', publication.outcomes.map(outcome => outcome.slug));
    window.toggleGatewayForm("eligible-step-one")
  };

  return (
    <div className={styles.formStickyCTA}>
        <div className={styles.text}>Need more guidance?</div>
        <Button text="Apply for legal advice" variant="secondary" onClick={toggleForm}>{' '}</Button>
    </div>
  )
}

export default FormStickyCTA;